// 24 oficjalne języki Unii Europejskiej (kod ISO 639-1 + endonim)
export interface LanguageOption {
  code: string;
  label: string; // nazwa w danym języku (endonim)
}

export const EU_LANGUAGES: LanguageOption[] = [
  { code: "pl", label: "Polski" },
  { code: "en", label: "English" },
  { code: "de", label: "Deutsch" },
  { code: "fr", label: "Français" },
  { code: "es", label: "Español" },
  { code: "it", label: "Italiano" },
  { code: "pt", label: "Português" },
  { code: "nl", label: "Nederlands" },
  { code: "cs", label: "Čeština" },
  { code: "sk", label: "Slovenčina" },
  { code: "sl", label: "Slovenščina" },
  { code: "hr", label: "Hrvatski" },
  { code: "bg", label: "Български" },
  { code: "ro", label: "Română" },
  { code: "hu", label: "Magyar" },
  { code: "el", label: "Ελληνικά" },
  { code: "da", label: "Dansk" },
  { code: "sv", label: "Svenska" },
  { code: "fi", label: "Suomi" },
  { code: "et", label: "Eesti" },
  { code: "lv", label: "Latviešu" },
  { code: "lt", label: "Lietuvių" },
  { code: "ga", label: "Gaeilge" },
  { code: "mt", label: "Malti" },
];

export const DEFAULT_LANGUAGE = "pl";

export const SUPPORTED_LANGUAGE_CODES = EU_LANGUAGES.map((l) => l.code);
